const MODULE_RELOAD_AT_KEY = 'invoice-platform:module-reload-at';
const MODULE_RELOAD_COOLDOWN_MS = 30_000;

export function shouldReloadAfterModuleFailure(lastReloadAt: string | null, now: number) {
  if (!lastReloadAt) return true;

  const parsedLastReloadAt = Number(lastReloadAt);
  return !Number.isFinite(parsedLastReloadAt)
    || now - parsedLastReloadAt >= MODULE_RELOAD_COOLDOWN_MS;
}

export function installModuleLoadRecovery() {
  window.addEventListener('vite:preloadError', (event) => {
    const now = Date.now();
    if (!shouldReloadAfterModuleFailure(sessionStorage.getItem(MODULE_RELOAD_AT_KEY), now)) {
      return;
    }

    event.preventDefault();
    sessionStorage.setItem(MODULE_RELOAD_AT_KEY, String(now));
    window.location.reload();
  });
}
